<script>
    import dwcLogo from '../../assets/dwc.png';
</script>

<header
    class="bg-dwc-100 shadow-black-200 relative z-20 flex h-16 items-center justify-center px-4 py-2 shadow-md"
    id="frontendHeader">
    <img alt="DWC-Tools Logo" class="w-34" src={dwcLogo} />
</header>
